import MainLayout from '@/common/components/layouts/MainLayout';
import { ADJUSTER_REPORT_CULPRIT_LINKS } from '@/modules/adjusterReportModules/adjusterReport/links/culprit/culpritLinks';
import { VehicleImagePreview } from '@/modules/adjusterReportModules/adjusterReport/pages/ImagePreview/vehicleImagePreview';
import { useNavigate, useParams } from 'react-router-dom';

export default function VehicleCulpritImagePreviewPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const navigateToRepeatCapturing = () => {
    navigate(
      ADJUSTER_REPORT_CULPRIT_LINKS.CULPRIT_IMAGES({
        id: +id!,
      }).ADJUSTER_VEHICLE.takePhotoFlow,
      { replace: true },
    );
  };
  const BackToImagesTab = () => {
    navigate(
      ADJUSTER_REPORT_CULPRIT_LINKS.CULPRIT_IMAGES({
        id: +id!,
      }).imagesTabPage,
      { replace: true },
    );
  };
  return (
    <MainLayout title="مقصر / تصاویر" header="onlyTitleHeader">
      <VehicleImagePreview
        BackToImagesTab={BackToImagesTab}
        navigateToRepeatCapturing={navigateToRepeatCapturing}
        userType="culprit"
      />{' '}
    </MainLayout>
  );
}
